export default __webpack_public_path__ + "static/media/champions.d7cf368c.svg";